export default {
  en: {
    'components.role-form.label': 'Role',
    'components.role-form.placeholder': 'Select Role',
    'components.role-form.submit': 'Save',
    'components.role-form-stat.label': 'Role',
  },
};
